/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { IEshopOrderSummaryData } from './eshop-order-summary.data';
import { IEshopOrderSummaryProps, IEshopOrderSummaryConfig } from './eshop-order-summary.props.autogenerated';
import { Cart, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { getCheckoutState, getCartState, ICartState } from '@msdyn365-commerce/global-state';
import { getActiveCheckoutCartProductsAction, ActiveCheckoutCartProductsInput } from './actions/get-products-in-active-ecomm-checkout-cart';
export interface IEshopOrderSummaryViewProps extends IEshopOrderSummaryProps<IEshopOrderSummaryData> {
    cart: Cart;
    products: SimpleProduct[];
    config: IEshopOrderSummaryConfig;
    cartItems: ICartState;
    callbacks: IOrderSummaryCallbacks;
    //removeCartItem: boolean;
    //modelOpenValue: boolean;
}
export interface IDimensionsionString {
    /** String for size key  */
    sizeString: string;
    /** String for color key  */
    colorString: string;
    /** String associated with the configuration product dimension  */
    configString: string;
    /** String for style key  */
    styleString: string;
    /** String for amount key  */
    amountString?: string;
}
export interface IOrderSummaryCallbacks {
    updateCartState(removeCartItem: boolean): void;
}

export interface IEshopOrderSummaryState {
    cart: Cart | null;
    products: SimpleProduct[] | null;
    modelOpenValue: boolean;
    cartItems: ICartState | null;
    removeCartItem: boolean;
    callbacks: IOrderSummaryCallbacks;
}
/**
 *
 * EshopOrderSummary component
 * @extends {React.PureComponent<IEshopOrderSummaryProps<IEshopOrderSummaryData>>}
 */
class EshopOrderSummary extends React.PureComponent<IEshopOrderSummaryProps<IEshopOrderSummaryData>, IEshopOrderSummaryState> {
    constructor(props: IEshopOrderSummaryProps<IEshopOrderSummaryData>) {
        super(props);

        this.state = {
            cart: null,
            products: null,
            modelOpenValue: false,
            cartItems: null,
            removeCartItem: false,
            callbacks: this.callbacks
        };
    }

    private readonly callbacks: IOrderSummaryCallbacks = {
        updateCartState: async (removeCartItem: boolean): Promise<void> => {
            const ctx = this.props.context.actionContext;
            const checkoutState = await getCartState(ctx);
            const actionInput = new ActiveCheckoutCartProductsInput();
            const productsState = await getActiveCheckoutCartProductsAction(actionInput, ctx);

            this.setState({ cart: checkoutState.cart });
            this.setState({ products: productsState });
            this.setState({ cartItems: checkoutState });
            this.setState({ callbacks: this.callbacks });
            this.setState({ removeCartItem: removeCartItem });
        }
    };

    public async componentDidMount(): Promise<void> {
        const checkoutState = await getCheckoutState(this.props.context.actionContext);
        // this.state['cart'] = checkoutState.checkoutCart.cart;
        this.setState({ cart: checkoutState.checkoutCart.cart });
    }

    public async componentDidUpdate(
        prevProps: Readonly<IEshopOrderSummaryProps<IEshopOrderSummaryData>>,
        prevState: Readonly<{}>,
        snapshot?: any
    ): Promise<void> {
        const ctx = this.props.context.actionContext;
        const checkoutState = await getCartState(ctx);
        const actionInput = new ActiveCheckoutCartProductsInput();
        const productsState = await getActiveCheckoutCartProductsAction(actionInput, ctx);
        if (this.state['cart'] !== checkoutState.cart) {
            this.setState({ cart: checkoutState.cart });
        }

        // this.state['products'] = productsState;
        this.setState({ products: productsState });

        if (this.state.cartItems !== checkoutState) {
            // this.state['cartItems'] = checkoutState;
            this.setState({ cartItems: checkoutState });
        }

        // this.state['callbacks'] = this.callbacks;
        this.setState({ callbacks: this.callbacks });

        this.setState({
            modelOpenValue: this.props.data.modelOpenValue.result?.modelOpenValue ?? false
        });
    }

    public render(): JSX.Element | null {
        const IEshopOrderSummaryViewProps = {
            ...this.props,
            cart: this.state['cart'],
            products: this.state['products'],
            cartItems: this.state['cartItems'],
            callbacks: this.state['callbacks']
        };
        return this.props.renderView(IEshopOrderSummaryViewProps);
    }
}

export default EshopOrderSummary;
